export default "__VITE_ASSET__B9IHo6WM__"